import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export const START_RECOGNITION = 'VOICE_TO_TEXT/START_RECOGNITION';

export const startRecognitionActionSchema = objectSchemaOf<
  IStartRecognitionAction
>({
  type: Joi.string().required().valid(START_RECOGNITION),
  payload: Joi.object({
    conversationId: Joi.string().required(),
  }).required(),
});

export interface IStartRecognitionAction {
  type: typeof START_RECOGNITION;
  payload: {
    conversationId: string;
  };
}

export const startRecognition = actionCreator({
  type: START_RECOGNITION,
  schema: startRecognitionActionSchema,
});
